package us.laantech.laanmanage.feature.store.settings

import androidx.lifecycle.ViewModel
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

data class StoreSettingsUiState(
    val department: String = "Store Settings View",
)

class StoreSettingsViewModel: ViewModel() {

    private val _uiState = MutableStateFlow(StoreSettingsUiState())
    val uiState = _uiState.asStateFlow()


}